import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_742_7961)">
      <path
        d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM16.6729 8.25977C16.2642 7.88831 15.6313 7.91851 15.2598 8.32715L10.9648 13.0508L8.70703 10.793L8.63086 10.7246C8.23809 10.4043 7.65908 10.4269 7.29297 10.793C6.90244 11.1835 6.90244 11.8165 7.29297 12.207L10.293 15.207C10.4863 15.4003 10.7502 15.5064 11.0234 15.5C11.2968 15.4935 11.5563 15.3752 11.7402 15.1729L16.7402 9.67285C17.1117 9.26419 17.0815 8.63126 16.6729 8.25977Z"
        fill="#42B677"
      />
      <path
        d="M8 11.5L11 14.5L16 9"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_742_7961">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
